import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PopinAvisGoogleDetailsComponent } from '@components/avis-google-details/popin-avis-google-details';
import { AvisGoogle } from '@components/avis-google/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { ReviewBadgeComponent } from '@shared/components/review-badge';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { DialogService } from '@shared/services/dialog';

@Component({
  selector: 'app-avis-google',
  imports: [TitleComponent, ButtonComponent, ImageComponent, SvgComponent, RouterLink, ReviewBadgeComponent],
  templateUrl: './avis-google.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvisGoogleComponent extends AbstractDynamicComponent<AvisGoogle> {
  private readonly dialogService = inject(DialogService);

  constructor() {
    super();
  }

  openGoogleReviewsPopup(): void {
    const gtm = this.data.gtmConfigBtnReviews;
    this.emitGtmEvent({
      event: gtm?.event,
      group: gtm?.group,
      description: gtm?.description,
      context: gtm?.context,
      button_text_value: this.data.buttonAvis,
      event_type: 'click',
    });
    this.dialogService.openDialog(PopinAvisGoogleDetailsComponent, 'BIG', {
      data: {
        title: this.data.popinTitle,
        reviewStats: this.data.reviewStats,
      },
    });
  }
}
